import axios from 'axios';

const defaultState = {
  dashboards: [],
  adminDashboards: [],
}

export default {
  namespaced: true,

  state: {
    dashboards: [],
    adminDashboards: [],
    dashboardLoading: false
  },

  mutations: {
    setDashboards(state, data) {
      state.dashboards = data;
    },

    setAdminDashboards(state, data) {
      state.adminDashboards = data;
    },

    setDashboardLoading(state, isloading) {
      state.dashboardLoading = isloading;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    fetchDashboards({ commit, dispatch }) {
      return axios.get(`${process.env.VUE_APP_API_URL}dashboards`)
        .then(({ data }) => commit('setDashboards', data || []))
        .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    deleteDashboard(_, dashboardId) {
      return axios.delete(process.env.VUE_APP_API_URL + 'dashboards/' + dashboardId);
    },

    fetchAdminDashboards({ commit, dispatch }) {
      return axios.get(`${process.env.VUE_APP_API_URL}admin/dashboards`)
        .then(({ data }) => commit('setAdminDashboards', data || []))
        .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    updateDashboard(_, { id, dashboard }) {
      return axios.put(process.env.VUE_APP_API_URL + `dashboards/${id}`, dashboard);
    },

    saveDashboard(_, dashboard) {
      return axios.post(process.env.VUE_APP_API_URL + 'dashboards', dashboard);
    }
  }
};